const DEFAULT_PROMOTION_ROLLOUT = {
  enabled: true,
  rolloutStage: "full",
  pageBannerEnabled: true,
  slideUpEnabled: true,
  modalEnabled: true,
};

const normalizeBoolean = (value, fallback = false) => {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "yes", "on"].includes(normalized)) return true;
    if (["false", "0", "no", "off"].includes(normalized)) return false;
  }
  return Boolean(value);
};

export const normalizePromotionRolloutConfig = (value = {}) => ({
  enabled: normalizeBoolean(value?.enabled, DEFAULT_PROMOTION_ROLLOUT.enabled),
  rolloutStage:
    String(value?.rolloutStage || DEFAULT_PROMOTION_ROLLOUT.rolloutStage).trim() ||
    DEFAULT_PROMOTION_ROLLOUT.rolloutStage,
  pageBannerEnabled: normalizeBoolean(
    value?.pageBannerEnabled,
    DEFAULT_PROMOTION_ROLLOUT.pageBannerEnabled,
  ),
  slideUpEnabled: normalizeBoolean(
    value?.slideUpEnabled,
    DEFAULT_PROMOTION_ROLLOUT.slideUpEnabled,
  ),
  modalEnabled: normalizeBoolean(
    value?.modalEnabled,
    DEFAULT_PROMOTION_ROLLOUT.modalEnabled,
  ),
});

export const isPromotionPlacementEnabled = (
  rolloutConfig = DEFAULT_PROMOTION_ROLLOUT,
  placement = "",
) => {
  const rollout = normalizePromotionRolloutConfig(rolloutConfig);
  if (!rollout.enabled || rollout.rolloutStage.toLowerCase() === "paused") return false;

  switch (String(placement || "").trim()) {
    case "page-banner":
      return rollout.pageBannerEnabled;
    case "slide-up":
      return rollout.slideUpEnabled;
    case "modal-popup":
      return rollout.modalEnabled;
    default:
      return true;
  }
};

export { DEFAULT_PROMOTION_ROLLOUT };
